import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NAV_ICON_PATHS, type NavIconName } from './nav-icon.model';

@Component({
  selector: 'mg3p-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      class="mg3p-icon"
      [class.mg3p-icon--sm]="size() === 'sm'"
      [class.mg3p-icon--md]="size() === 'md'"
      [class.mg3p-icon--lg]="size() === 'lg'"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      @for (d of paths(); track $index) {
        <path [attr.d]="d" />
      }
    </svg>
  `,
  styles: [
    `
      .mg3p-icon {
        display: block;
        flex-shrink: 0;
        width: 1.25rem;
        height: 1.25rem;
      }
      .mg3p-icon--sm {
        width: 1rem;
        height: 1rem;
      }
      .mg3p-icon--md {
        width: 1.25rem;
        height: 1.25rem;
      }
      .mg3p-icon--lg {
        width: 1.5rem;
        height: 1.5rem;
      }
    `,
  ],
})
export class IconComponent {
  readonly name = input.required<NavIconName>();
  readonly size = input<'sm' | 'md' | 'lg'>('md');

  readonly paths = computed(() => NAV_ICON_PATHS[this.name()] ?? []);
}
